// extracted by mini-css-extract-plugin
module.exports = {"mobileNav":"MobileNavigationItems_mobileNav__oaYyU","navItem":"MobileNavigationItems_navItem__gl5E_"};